import * as Yup from 'yup'

export const JobsValidationSchema = Yup.object().shape({
  jobs: Yup.array().of(
    Yup.object().shape({
      company: Yup.string().required('Se requiere el nombre de la empresa'),
      entryDate: Yup.date().nullable(),
      leaveDate: Yup.date().nullable(),
      reasonLeaving: Yup.string(),
      occupations: Yup.array()
        .of(
          Yup.object().shape({
            occupation: Yup.string().optional().nullable(),
            otro: Yup.string().optional(),
          }),
        )
        .min(1, 'Se requiere al menos una ocupación'),
    }),
  ),
})
